import React from 'react'

import ListGroup from 'react-bootstrap/ListGroup'
import Stack from 'react-bootstrap/Stack'

import { useInventory } from '../../../../InventoryProvider/InventoryProvider'
import { ListItem } from './ListItem'
import { Item } from '../Item'

export default function InventoryMenu({
  canEdit,
  isEventOnsale,
  holds,
  kills,
  offers,
  sold,
  resale,
  allowResales,
  handleRemove,
  handleAdd,
  getObjectTotalSeatCount,
  isDroppableInSelected,
}) {
  const { setHolds, setKills, holdLetterMap } = useInventory()
  const resaleItem = resale?.[Object.keys(resale || {})[0]] || {
    id: 'resale',
    name: 'Resale',
    seats: [],
    gaSeats: {},
  }
  const resaleCount = getObjectTotalSeatCount(resaleItem)
  const showResale = allowResales && resaleCount > 0
  return (
    <div className="list-container inventory-container">
      <ListGroup as="ul" variant="flush">
        <ListGroup.Item as="li">
          <ListItem
            title="Offers"
            data={offers}
            getObjectTotalSeatCount={getObjectTotalSeatCount}
            isDroppableInSelected={isDroppableInSelected}
            canEdit={canEdit}
          />
        </ListGroup.Item>
        <ListGroup.Item as="li">
          <ListItem
            title="Holds"
            data={holds}
            handleRemove={handleRemove}
            handleAdd={handleAdd}
            getObjectTotalSeatCount={getObjectTotalSeatCount}
            isDroppableInSelected={isDroppableInSelected}
            canEdit={canEdit}
            setHolds={setHolds}
            setKills={setKills}
            holdLetterMap={holdLetterMap}
          />
        </ListGroup.Item>
        <ListGroup.Item as="li">
          <ListItem
            title="Kills"
            data={kills}
            handleRemove={handleRemove}
            handleAdd={handleAdd}
            getObjectTotalSeatCount={getObjectTotalSeatCount}
            isDroppableInSelected={isDroppableInSelected}
            canEdit={canEdit}
            setHolds={setHolds}
            setKills={setKills}
          />
        </ListGroup.Item>
        {(isEventOnsale ||
          (sold &&
            Object.keys(sold).length > 0 &&
            (sold[Object.keys(sold)[0]]?.seats?.length > 0 ||
              Object.keys(sold[Object.keys(sold)[0]]?.gaSeats || {}).length >
                0))) && (
          <ListGroup.Item as="li">
            <div className="heading--flex-space-between mb-2">
              <span className="fw-semi-bold">Sold</span>
            </div>
            <Stack as="ul">
              <li>
                <Item
                  el={sold[Object.keys(sold)[0]]}
                  getObjectTotalSeatCount={getObjectTotalSeatCount}
                />
              </li>
            </Stack>
          </ListGroup.Item>
        )}
        {showResale && (
          <ListGroup.Item as="li">
            <div className="heading--flex-space-between mb-2">
              <span className="fw-semi-bold">Resale</span>
            </div>
            <Stack as="ul">
              <li>
                <Item
                  el={resaleItem}
                  getObjectTotalSeatCount={getObjectTotalSeatCount}
                />
              </li>
            </Stack>
          </ListGroup.Item>
        )}
      </ListGroup>
    </div>
  )
}
